/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, number, shape, string, bool, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Media from 'react-media';
import BackButton from '../../common/BackButton';
import { convertToYYYYMMDD, dateMMMMDDYYYY } from '../../utils/dateString';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import DesktopPassport from './DesktopPassport/DesktopPassport';
import { getFeatureFlags } from '../../utils/featureSelectors';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { triggerPassportSubscription } from '../../../../../state/ducks/Checkout/ducks/Payment/ducks/Passport/Passport-Action';
import { getCartData, getCartOrderDetails } from '../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';

class Passport extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { fetchUserProfile } = this.props;
        fetchUserProfile();
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    errorPage = () => (
        <>
            <h1>
                <BackButton />
                Passport
            </h1>
            <div>
                Sorry! The data is not available at this time. Please try again
                later.
            </div>
        </>
    );

    handleSubscriptionRenewal = () => {
        const { triggerSubscription } = this.props;
        if (triggerPassportSubscription) triggerSubscription();
    }

    render() {
        const {
            userProfile,
            userProfile: { email, XAtt4, XAtt5 },
            history,
            featureFlags,
            cartData,
            orderData,
        } = this.props;
        if (!email || !XAtt4 || !XAtt5) return null;
        let startDate;
        let endDate;
        let memberSince;
        let renewalDate;
        let isActive = false;
        try {
            const XAtt4ToYYYYMMDD = convertToYYYYMMDD(XAtt4);
            const XAtt5ToYYYYMMDD = convertToYYYYMMDD(XAtt5);
            startDate = dateMMMMDDYYYY(XAtt4ToYYYYMMDD);
            endDate = dateMMMMDDYYYY(XAtt5ToYYYYMMDD);
            const startDateObj = new Date(XAtt4ToYYYYMMDD);
            const endDateObj = new Date(XAtt5ToYYYYMMDD);
            memberSince = startDateObj.getFullYear();
            renewalDate = dateMMMMDDYYYY(endDateObj, 0, 0, 1);
            isActive = new Date().getTime() < endDateObj.getTime();
        } catch (ex) {
            return this.errorPage();
        }
        const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
        return (
            <Media query={breakpointExpr}>
                {(matches) => (
                    matches ? (
                        <>
                            <h1>
                                <BackButton />
                                Passport
                            </h1>
                            <div className="">
                                <h2 className="h2Divider">Membership Details</h2>
                                <div className="margin-bottom-2x margin-top-2x">
                                    <span className="gray-text spacing-right">Member Email:</span>
                                    <span className="bold">{email}</span>
                                </div>
                                <div className="margin-bottom-2x">
                                    <span className="gray-text spacing-right">Member Since:</span>
                                    <span className="bold">{memberSince}</span>
                                </div>
                                <div className="margin-bottom-2x">
                                    <span className="gray-text spacing-right">Membership Start Date:</span>
                                    <span className="bold">{startDate}</span>
                                </div>
                                <div className="margin-bottom-2x">
                                    <span className="gray-text spacing-right">Membership End Date:</span>
                                    <span className="bold">{endDate}</span>
                                </div>
                                <div className="margin-bottom-2x">
                                    <span className="gray-text spacing-right">Renewal Date:</span>
                                    <span className="bold">{renewalDate}</span>
                                </div>
                                <div className="margin-bottom-2x">
                                    <span className="gray-text spacing-right">Status:</span>
                                    <span className="bold">{isActive ? 'Active' : 'Inactive'}</span>
                                </div>
                                <div className="margin-bottom-2x padding-top">
                                    <div className="align-center">Your default card will be used for</div>
                                    <div className="align-center">Passport membership renewals.</div>
                                </div>
                            </div>
                        </>
                    )
                        :                        (
                            <>
                                <DesktopPassport
                                    history={history}
                                    userProfile={userProfile}
                                    featureFlags={featureFlags}
                                    handleSubscriptionRenewal={this.handleSubscriptionRenewal}
                                    cartData={cartData}
                                    orderData={orderData}
                                />
                            </>
                        )
                )}
            </Media>
        );
    }
}

Passport.defaultProps = {
    history: {},
    userProfile: {},
    featureFlags: {},
    orderData: {},
    cartData: {},
};

Passport.propTypes = {
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
        XAtt4: string,
        XAtt5: string,
    }),
    orderData: shape({
        orderId: string,
    }),
    fetchUserProfile: func.isRequired,
    triggerSubscription: func.isRequired,
    history: object,
    featureFlags: object,
    cartData: shape({
        orderDetails: shape({
            fdOrderVO: shape({
                recipients: arrayOf(shape({
                    orderItems: arrayOf(shape({
                        catalogEntryVO: shape({
                            primeFreeShipFlag: string,
                        }),
                    })),
                })),
            }),
        }),
    }),
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state.account ? state.account : state;
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        cartData: getCartData(state),
        orderData: getCartOrderDetails(state),
        userProfile: newState.userProfile,
        featureFlags,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
    triggerSubscription: () => dispatch(triggerPassportSubscription('product')), // product OR payment
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter((Passport)));
